import React, { ReactElement } from 'react';
import { useRouteMatch } from 'react-router-dom';

function SinglePage(): ReactElement {
    const { path } = useRouteMatch();
    const pathArray = path.split('/');

    const getComponent = (): ReactElement => {
        if (pathArray.length >= 4) {
            const CurrentPageModel = React.lazy(() => import(`../../${pathArray[1]}/${pathArray[2]}/${pathArray[3]}`).catch(() => ''));
            return <CurrentPageModel />;
        }
        const CurrentPage = React.lazy(() => import(`../../${pathArray[1]}/${pathArray[2]}`).catch(() => ''));
        return <CurrentPage />;
    };

    return <>{getComponent()}</>;
}

export default SinglePage;
